import { Button } from '@/components/ui/Button';
import { SHOWN_ROWS_STEP } from '@/lib/useShownRows';

/** The press under a long list that draws its next rows, saying how many are
 *  not yet shown. Nothing when every row is shown. */
export function ShowMoreButton({
  hidden,
  what,
  onClick,
}: {
  hidden: number;
  what: string;
  onClick: () => void;
}) {
  if (hidden <= 0) return null;
  return (
    <Button variant="link" size="sm" className="my-1 px-2" onClick={onClick}>
      Show {Math.min(hidden, SHOWN_ROWS_STEP).toLocaleString()} more ({hidden.toLocaleString()}{' '}
      {what} not shown)
    </Button>
  );
}
